<template>
	<b-modal
		id="communication-modal"
		centered
		hide-footer
		hide-header
		class="qb-add-ques-modal"
		size="lg"
		no-close-on-backdrop
		v-model="showModal"
	>
		<div class="modalheading">{{ status }} Communication</div>
		<div @click="$emit('close-modal')" class="xMarkCancel">
			<img src="../../assets/xmark.svg" alt="" />
		</div>
		<div :class="{ 'form-disabled': isUploadLocked }">
			<div class="qb-match-options-overflow" ref="mcqModalContent">
				<b-row>
					<b-col>
						<div class="topDiv mt-3 relativeclass">
							<label class="disabledfieldsetStyle"
								>Question Type &nbsp;<span class="asterik">*</span></label
							>
							<b-form-input
								type="text"
								value="Communication"
								class="disabledinputField"
								disabled
							></b-form-input>
						</div>
					</b-col>
					<b-col>
						<div class="topDiv mt-3 relativeclass">
							<label class="disabledfieldsetStyle"
								>Marks &nbsp;<span class="asterik">*</span></label
							>
							<b-form-input
								class="disabledinputField"
								type="number"
								v-model="communication.marks"
								@keypress="validateInput($event)"
								placeholder="Marks"
								disabled
							></b-form-input>
						</div>
					</b-col>
				</b-row>
				<b-row class="questiontagcontainer">
					<b-col cols="6">
						<div class="topDiv mt-3 qb-other-textDIff">
							<label class="fieldsetStyle"
								>Difficulty Level &nbsp;<span class="asterik">*</span></label
							>
							<div
								class="editquesdropdown d-flex justify-content-between pointer"
								@click="qbdropdiff = !qbdropdiff"
								ref="dropdiff"
								:class="{
									error: $v.communication.difficultyLevel.$error,
								}"
							>
								<span
									>Difficulty Level {{ communication.difficultyLevel }}</span
								>
								<span>
									<img
										v-if="qbdropdiff"
										src="../../assets/uparrow.svg"
										alt=""
										class="mr-1"
									/>
									<img
										v-else
										src="../../assets/downarrow.svg"
										alt=""
										class="mr-1"
									/>
								</span>
							</div>
							<div
								style="position: absolute; top: 20%; right: 10%"
								v-if="
									$v.communication.difficultyLevel.$dirty &&
										!$v.communication.difficultyLevel.required
								"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								v-if="qbdropdiff"
								v-closable="{
									exclude: ['dropdiff'],
									handler: 'hideDiffOptions',
								}"
								class="qb-dropdown-option-add-1 d-flex"
							>
								<b-form-group
									class="qb-dd-group-diff"
									v-slot="{ ariaDescribedby }"
								>
									<b-form-radio-group
										@change="qbdropdiff = !qbdropdiff"
										class="qb-add-drop width-full"
										id="btn-radios-4"
										v-model="$v.communication.difficultyLevel.$model"
										:options="diffoptions"
										:aria-describedby="ariaDescribedby"
										name="radio-btn-stacked"
										buttons
										stacked
									></b-form-radio-group>
								</b-form-group>
							</div>
						</div>
					</b-col>
					<b-col cols="6">
						<div class="qb-blue-parent topDiv mt-3 ckeditor">
							<label class="addquesboxfieldsetStyle"> Question Tags</label>
							<b-form-tags
								remove-on-delete
								v-model="communication.questionTags"
								no-outer-focus
								separator=" "
								add-on-change
							>
								<template
									v-slot="{
										tags,
										inputAttrs,
										inputHandlers,
										tagVariant,
										removeTag,
										addTag,
									}"
								>
									<b-input-group class="mb-2" id="mcqaddcontainer-tag">
										<div
											style="width: 85%"
											class="qb-transparent d-flex cust-group-input"
										>
											<div
												class="d-inline-block cust-btn-select mt-2"
												style="font-size: 1.5rem"
											>
												<b-form-tag
													v-for="tag in tags"
													@remove="removeTag(tag)"
													:key="tag"
													:title="tag"
													:variant="tagVariant"
													class="ml-1"
													>{{ tag }}</b-form-tag
												>
											</div>
											<b-form-input
												id="mcq-add-tag"
												v-bind="inputAttrs"
												v-on="inputHandlers"
												@keyup="hashtagmcqadd()"
												@keyup.enter="addTagAndResetInputMCQ()"
												@keyup.space="addTagAndResetInputMCQ()"
												@keydown.tab.prevent="addTagAndResetInputMCQ()"
												placeholder="Enter Question tag"
												style="border-bottom: unset"
												class="form-control min-width mr-4 ml-2"
												v-model="tagmodal"
											></b-form-input>
										</div>
										<b-input-group-append>
											<b-button
												:disabled="tagmodal == ''"
												@click="addTag(), (tagmodal = '')"
												variant="outline"
												class="cursor-pointer"
											>
												<img src="../../assets/addicongraywhite.svg" alt="" />
											</b-button>
										</b-input-group-append>
									</b-input-group>
								</template>
							</b-form-tags>
						</div>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<div class="topDiv mt-3 relativeclass">
							<div :class="!$v.communication.question.maxLength ? 'error' : ''">
								<label class="addquesboxfieldsetStyle" style="z-index: 5">
									Question &nbsp;<span class="asterik">*</span></label
								>
								<QuillEditor
									:value="$v.communication.question.$model"
									@questionText="updateData('question', $event)"
								>
								</QuillEditor>

								<div
									style="position: absolute; top: 5px; right: 18px"
									v-if="
										$v.communication.question.dirty &&
											!$v.communication.question.required
									"
									v-b-popover.hover.top.v-danger="{
										content: 'Required',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>

								<div
									style="position: absolute; top: 5px; right: 18px"
									v-if="!$v.communication.question.maxLength"
									v-b-popover.hover.top.v-danger="{
										content: 'Should not exceed 10000 characters',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</div>
							<div class="media-box mt-2 align-items-center">
								<div class="d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center">
										<div class="media-text ml-3">Add Media</div>
										<div class="ml-2">
											<img src="../../assets/vertical-line.svg" alt="" />
										</div>
										<div class="d-flex align-items-center ml-2 mt-1">
											<div
												class="ml-2"
												v-b-tooltip.hover="{ variant: 'secondary' }"
												title=" Audio supported formats are: wav, mp3"
											>
												<label for="file-upload-modal" class="pointer">
													<img src="../../assets/headphone.svg" alt="" />
												</label>
												<input
													id="file-upload-modal"
													type="file"
													accept="audio/*"
													@change="previewFile"
												/>
											</div>
											<div
												class="ml-3"
												v-b-tooltip.hover="{ variant: 'secondary' }"
												title=" Video supported formats is: mp4"
											>
												<label for="file-upload-video-modal" class="pointer">
													<img src="../../assets/videocam.svg" alt="" />
												</label>
												<input
													id="file-upload-video-modal"
													type="file"
													accept="video/*"
													@change="previewFile"
												/>
											</div>
											<div
												class="ml-3"
												v-b-tooltip.hover="{ variant: 'secondary' }"
												title="Image supported formats are: jpg, jpeg, png"
											>
												<label for="file-upload-image-modal" class="pointer">
													<img src="../../assets/image-capture.svg" alt="" />
												</label>
												<input
													id="file-upload-image-modal"
													type="file"
													accept="image/*"
													@change="previewFile"
												/>
											</div>
										</div>
									</div>
									<div
										class="d-flex align-items-center"
										v-if="communication.isFailed == true"
									>
										<img src="../../assets/Vector.svg" alt="" class="mr-2" />
										<p class="uploadfailed mb-0 mr-2">Invalid media file</p>
									</div>
								</div>
							</div>
						</div>
					</b-col>
					<b-col cols="12">
						<template>
							<div
								v-if="
									communication.questionMedia != null && this.checkMedia == true
								"
								class="mt-4 mediaPosition"
							>
								<div class="relativeclass">
									<div @click="cancelMedia()" class="qb-cancel-image">
										<img src="../../assets/CloseImg.svg" alt="" />
									</div>
									<div
										class="dbmcqcardimage"
										v-if="isImage(communication.questionMediaType)"
									>
										<img
											class="w-100 h-100"
											:src="communication.questionMedia"
											alt=""
										/>
									</div>
									<div v-if="isAudio(communication.questionMediaType)">
										<Media
											:kind="'audio'"
											:isMuted="false"
											:src="communication.questionMedia"
											:autoplay="false"
											:controls="true"
											:loop="true"
											width="70%"
											class="qb-audio-preview"
										></Media>
									</div>
									<div v-if="isVideo(communication.questionMediaType)">
										<Media
											:kind="'video'"
											:isMuted="false"
											:src="communication.questionMedia"
											:autoplay="false"
											:controls="true"
											:loop="true"
											width="70%"
											height="30%"
											class="qb-vedio-preview"
										></Media>
									</div>
								</div>
							</div>
						</template>
					</b-col>
				</b-row>
				<b-row v-if="showVideoUploading" ref="uploadSection">
					<b-col class="ab-uploaded-card w-100 mt-3">
						<b-card no-body class="d-flex w-100">
							<section class="d-flex align-items-center pt-1">
								<div
									class="ab-uploaded-file-heading d-flex align-items-center w-75"
								>
									{{ videoData.name }}
								</div>

								<div
									class="ab-uploaded-file-subheading w-20 d-flex justify-content-end align-items-center gap-2"
								>
									<b-spinner v-if="showSpinner" label="Spinning"></b-spinner>
									<span>{{ formatSize(videoData.size) }}</span>
									<!-- <span class="ml-2"> 2 sec Left</span> -->
								</div>
								<!-- 
									<img
										:class="progress <= 0 ? 'opacity-50' : 'pointer'"
										@click="progress > 0 ? removeFile('video') : ''"
										class="ml-3"
										src="@/assets/common/blue-cross.svg"
										alt=""
									/> -->
							</section>
							<section class="mt-2">
								<b-progress height="4px" :value="progress"></b-progress>
							</section>
						</b-card>
					</b-col>
				</b-row>
			</div>

			<div class="mt-2 d-flex justify-content-end">
				<div>
					<b-button class="addbtn" @click="validateForm()">
						<span class="pl-2 pr-2 pt-1 pb-1">{{
							status === "Add" ? "Add" : "Update"
						}}</span>
					</b-button>
					<b-button
						class="cancel-btn"
						variant="outline"
						@click="$emit('close-modal')"
						>Cancel</b-button
					>
				</div>
			</div>
		</div>
	</b-modal>
</template>
<script>
import toast from "@/views/mixin/toast";
import { required, maxLength } from "vuelidate/lib/validators";
import QuillEditor from "../forms/quillEditor.vue";
import mediaUploadMixin from "@/views/mixin/mediaUploadMixin.js";
import socketUploadMixin from "@/views/mixin/socketUploadMixin.js";
import {
	addCommunicationTest,
	editCommunicationTest,
} from "@/utils/apiFunctions.js";
import { mapGetters } from "vuex";

export default {
	name: "CommunicationQuestionModal",
	mixins: [toast, mediaUploadMixin, socketUploadMixin],
	data() {
		return {
			showVideoUploading: false, // controls ab-uploaded-card visibility
			progress: 0, // progress bar value
			videoData: {}, // { name, size }
			showSpinner: false, // spinner near size
			qbdropdiff: false,
			checkMedia: false,
			mediaRemoved: false,
			communication: {
				questionType: "COMU",
				difficultyLevel: "",
				question: "",
				questionMedia: null,
				questionFile: null,
				questionMediaType: null,
				marks: 10,
				questionTags: [],
				addToPublic: "true",
				addToDatabank: "true",
			},
			diffoptions: [
				{
					value: "1",
					text: "Difficulty Level 1",
				},
				{
					value: "2",
					text: "Difficulty Level 2",
				},
				{
					value: "3",
					text: "Difficulty Level 3",
				},
				{
					value: "4",
					text: "Difficulty Level 4",
				},
				{
					value: "5",
					text: "Difficulty Level 5",
				},
			],
		};
	},
	components: {
		QuillEditor,
	},
	computed: {
		isUploadLocked() {
			return this.showVideoUploading;
		},
		...mapGetters("userVUEX", {
			licenseKey: "getlicenseKey",
		}),
	},
	props: {
		status: {
			type: String,
		},
		showModal: {
			type: Boolean,
			default: false,
		},
		selectedData: {
			type: Object,
		},
		fromCard: {
			type: Boolean,
			default: false,
		},
	},
	validations: {
		communication: {
			difficultyLevel: {
				required,
			},
			question: {
				required,
				maxLength: maxLength(10000),
			},
		},
	},

	created() {
		console.log("modal open", this.status);
		if (this.status === "Edit") {
			this.communication = JSON.parse(JSON.stringify(this.selectedData));
			this.mediaRemoved = false;
			this.checkMedia = !!this.communication.questionMedia;
		}
	},
	methods: {
		scrollToUpload() {
			const container = this.$refs.mcqModalContent;
			const target = this.$refs.uploadSection;

			if (!container || !target) return;

			const targetTop = target.offsetTop;

			container.scrollTo({
				top: targetTop - 20,
				behavior: "smooth",
			});
		},

		formatSize(bytes) {
			if (!bytes && bytes !== 0) return "";

			const kb = bytes / 1024;

			if (kb < 1024) {
				return `${kb.toFixed(1)} KB`;
			}

			return `${(kb / 1024).toFixed(1)} MB`;
		},
		async previewFile(event) {
			const file = event.target.files[0];
			if (!file) return;
			this.videoData = {
				name: file.name,
				size: file.size,
			};
			await this.handleMediaUpload(event, this.communication);
			this.checkMedia = !this.communication.isFailed;
		},

		updateData(key, data) {
			this.$v.communication[key].$model = data;
		},

		async submitCommunication() {
			try {
				this.showSpinner = true;

				let form = new FormData();
				const data = { ...this.communication };

				let bucketPath = null;

				//  1. Upload media via socket (ONLY change)
				if (data.questionFile) {
					this.showVideoUploading = true;

					await this.$nextTick(); // 👈 wait until row exists
					this.scrollToUpload(); // 👈 now scroll
					this.showVideoUploading = true;
					bucketPath = await this.uploadFileViaSocket(
						data.questionFile,
						data.fileMeta
					);
				}

				//  2. Cleanup media fields (binary should NOT go to API)
				delete data.questionFile;
				delete data.fileMeta;
				delete data.questionMedia;

				// 3. Append bucket path instead of file
				if (bucketPath) {
					data.questionMediaPath = bucketPath; // new upload
				} else if (this.mediaRemoved) {
					delete data.questionMediaPath; //  remove old path
					form.append("delete", 1);
				}

				// Everything else EXACTLY same as before
				for (const [key, value] of Object.entries(data)) {
					if (key === "questionTags") {
						form.append(key, JSON.stringify(value));
					} else {
						form.append(key, value);
					}
				}

				const apiFunc =
					this.status === "Add" ? addCommunicationTest : editCommunicationTest;

				const res = await apiFunc(form);

				if (res.status === 200) {
					if (this.fromCard) {
						this.$emit("get-sections");
					}
					this.$emit("get-questions");
					this.$emit("close-modal");
					this.$nextTick(() => {
						this.successToast(
							this.status === "Add"
								? "Question added successfully"
								: "Question updated successfully"
						);
					});
					this.showVideoUploading = false;
					this.showSpinner = false;
					this.progress = 0;
					this.videoData = {};
				}
			} catch (error) {
				this.errorToast(error?.message || "Error submitting question");
			}
		},
		validateForm() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.errorToast("Please fill all the details");
			} else {
				this.submitCommunication();
			}
		},

		cancelMedia() {
			this.communication.questionMedia = null;
			this.communication.questionMediaPath = null;
			this.communication.questionFile = null;
			this.communication.questionMediaType = null;
			this.checkMedia = false;
			this.mediaRemoved = true;
			// reset file inputs
			this.$nextTick(() => {
				const inputs = document.querySelectorAll('input[type="file"]');
				inputs.forEach((i) => (i.value = ""));
			});
			this.$forceUpdate();
		},

		addTagAndResetInputMCQ() {
			if (this.tagmodal.trim() !== "") {
				this.communication.questionTags.push(this.tagmodal.trim());
				this.tagmodal = "";
				this.$forceUpdate();
			}
		},
		hashtagmcqadd() {
			let str = document.getElementById("mcq-add-tag").value;
			let tagged = str.replace(/#/g, "").replace(/([a-zA-Z0-9]+)/g, "#" + "$1");
			document.getElementById("mcq-add-tag").value = tagged;
		},
	},
};
</script>
